import { border, ursaColors, lodestarColors, typography, motion } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { toRgba } from "../../constants/colors";

export const checkboxColors = themed({
    check: {
        background: {
            rest: {
                unchecked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--background--surfaces--work"),
                },
                checked: {
                    "lodestar-light": lodestarColors.buttonPrimary, //no token exists
                    "ursa-light": color("color--background--primary--default", ursaColors.blue500),
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": color("color--background--neutral--default", lodestarColors.neutralLight10),
                    "ursa-light": color("color--background--neutral--weaker", ursaColors.neutral50),
                },
                checked: {
                    "lodestar-light": lodestarColors.buttonPrimary, //no token exists
                    "ursa-light": color("color--background--primary--strong", ursaColors.blue600),
                    "ursa-dark": color("color--background--primary--strong", ursaColors.blue400),
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": color("color--background--neutral--default", lodestarColors.neutralLight10),
                    "ursa-light": color("color--background--neutral--default"),
                },
                checked: {
                    "lodestar-light": lodestarColors.buttonPrimary, //no token exists
                    "ursa-light": color("color--background--primary--stronger", ursaColors.blue700),
                    "ursa-dark": color("color--background--primary--stronger", ursaColors.blue300),
                },
            },
            disabled: {
                unchecked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--background--surfaces--work"),
                },
                checked: {
                    "lodestar-light": toRgba(lodestarColors.buttonPrimary, 0.4), //no token exists
                    "ursa-light": color("color--background--primary--weak", ursaColors.blue100),
                    "ursa-dark": color("color--background--primary--weak", ursaColors.blue600),
                },
            },
            invalid: {
                // Invalid bg styles are the same as valid bg styles.
                rest: {
                    checked: {
                        "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                        "ursa-light": color("color--background--destructive--default", ursaColors.red500),
                    },
                },
                hover: {
                    checked: {
                        "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                        "ursa-light": color("color--background--destructive--stronger", ursaColors.red600),
                    },
                },
                active: {
                    checked: {
                        "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                        "ursa-light": color("color--background--destructive--strongest", ursaColors.red700),
                    },
                },
            },
        },
        border: {
            rest: {
                unchecked: {
                    "lodestar-light": color("color--border--neutral--strong", lodestarColors.neutralAccessible),
                    "ursa-light": color("color--border--neutral--default", ursaColors.neutral300),
                },
                checked: "transparent",
            },
            hover: {
                unchecked: {
                    "lodestar-light": color("color--border--neutral--strong", lodestarColors.neutralAccessible),
                    "ursa-light": color("color--border--neutral--strong", ursaColors.neutral500),
                },
                checked: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": color("color--border--neutral--strong", lodestarColors.neutralAccessible),
                    "ursa-light": color("color--border--primary--default", ursaColors.blue500),
                    "ursa-dark": color("color--border--primary--default", ursaColors.blue300),
                },
                checked: "transparent",
            },
            disabled: {
                unchecked: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4), //no token exists
                    "ursa-light": color("color--background--neutral--weakest", ursaColors.neutral50),
                },
                checked: "transparent",
            },
            invalid: {
                rest: {
                    unchecked: {
                        "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                        "ursa-light": color("color--border--error--default", ursaColors.red500),
                        "ursa-dark": color("color--border--destructive--weak", ursaColors.red300),
                    },
                    checked: "transparent",
                },
                hover: {
                    unchecked: {
                        "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                        "ursa-light": color("color--background--destructive--stronger", ursaColors.red600),
                    },
                    checked: "transparent",
                },
                active: {
                    unchecked: {
                        "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                        "ursa-light": color("color--background--destructive--strongest", ursaColors.red700),
                    },
                    checked: "transparent",
                },
            },
        },
        icon: {
            rest: {
                unchecked: color("color--background--surfaces--body", lodestarColors.neutralLight40),
                checked: color("color--background--surfaces--body", lodestarColors.neutralLight40),
                outline: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--background--surfaces--body", ursaColors.neutral00),
                },
                checked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--background--surfaces--body", ursaColors.neutral00),
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": toRgba(lodestarColors.neutralLight40, 0.6), //no token exists
                    "ursa-light": color("color--background--surfaces--body", ursaColors.neutral00),
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--background--surfaces--body", ursaColors.neutral00),
                },
                outline: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--icons--neutral--weakest", ursaColors.neutral75),
                },
            },
            invalid: {
                rest: color("color--background--surfaces--body", lodestarColors.neutralLight40),
                hover: color("color--background--surfaces--body", lodestarColors.neutralLight40),
                active: color("color--background--surfaces--body", lodestarColors.neutralLight40),
            },
        },
    },
    flag: {
        background: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            invalid: {
                // Invalid bg styles are the same as valid bg styles.
                rest: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                hover: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                active: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
            },
        },
        border: {
            rest: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            disabled: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            invalid: {
                rest: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                hover: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                active: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
            },
        },
        icon: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": color("color--icons--destructive--strong", lodestarColors.visRedDark10),
                    "ursa-light": color("color--background--spectrum-red--default", ursaColors.red300), //no token exists
                },
                outline: {
                    "lodestar-light": color("color--icons--destructive--strong", lodestarColors.visRedDark10),
                    "ursa-light": color("color--icons--neutral--weaker", ursaColors.neutral200),
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--icons--neutral--weakest", ursaColors.neutral75),
                },
                checked: {
                    "lodestar-light": color("color--icons--destructive--strong", lodestarColors.visRedDark10),
                    "ursa-light": color("color--background--spectrum-red--stronger", ursaColors.red500),
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": color("color--background--neutral--default", lodestarColors.neutralLight10),
                    "ursa-light": color("color--text--neutral-inverse--weak", ursaColors.neutral50),
                },
                checked: {
                    "lodestar-light": color("color--icons--destructive--strong", lodestarColors.visRedDark10),
                    "ursa-light": color("color--background--spectrum-red--strong", ursaColors.red400),
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4), //no token exists
                    "ursa-light": color("color--background--spectrum-red--weak", ursaColors.red200),
                },
                outline: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4), //no token exists
                    "ursa-light": color("color--icons--neutral--weakest", ursaColors.neutral75),
                },
            },
            invalid: {
                rest: {
                    "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                    "ursa-light": color("color--icons--error--default", ursaColors.red500),
                },
                hover: {
                    "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                    "ursa-light": color("color--icons--destructive--stronger", ursaColors.red600),
                },
                active: {
                    "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                    "ursa-light": color("color--background--destructive--strongest", ursaColors.red700),
                },
            },
        },
    },
    star: {
        background: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
            },
            invalid: {
                // Invalid bg styles are the same as valid bg styles.
                rest: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                hover: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
                active: {
                    checked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                },
            },
        },
        border: {
            rest: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            hover: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            active: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            disabled: {
                unchecked: {
                    "lodestar-light": "transparent",
                    "ursa-light": "transparent",
                },
                checked: "transparent",
            },
            invalid: {
                rest: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                hover: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
                active: {
                    unchecked: {
                        "lodestar-light": "transparent",
                        "ursa-light": "transparent",
                    },
                    checked: "transparent",
                },
            },
        },
        icon: {
            rest: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": color("color--background--spectrum-yellow--default", lodestarColors.visYellow),
                    "ursa-light": color("color--background--spectrum-gold--default", ursaColors.gold300),
                },
                outline: {
                    "lodestar-light": color("color--background--spectrum-yellow--default", lodestarColors.visYellow),
                    "ursa-light": color("color--icons--neutral--weaker", ursaColors.neutral200),
                },
            },
            active: {
                unchecked: {
                    "lodestar-light": color("color--background--surfaces--body", lodestarColors.neutralLight40),
                    "ursa-light": color("color--icons--neutral--weakest", ursaColors.neutral75),
                },
                checked: {
                    "lodestar-light": color("color--background--spectrum-yellow--default", lodestarColors.visYellow),
                    "ursa-light": color("color--background--spectrum-gold--stronger", ursaColors.gold500),
                },
            },
            hover: {
                unchecked: {
                    "lodestar-light": color("color--background--neutral--default", lodestarColors.neutralLight10),
                    "ursa-light": color("color--background--neutral--weaker", ursaColors.neutral50),
                },
                checked: {
                    "lodestar-light": color("color--background--spectrum-yellow--default", lodestarColors.visYellow),
                    "ursa-light": color("color--background--spectrum-gold--strong", ursaColors.gold400),
                },
            },
            disabled: {
                unchecked: "transparent",
                checked: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4), //no token exists
                    "ursa-light": color("color--background--spectrum-gold--weak", ursaColors.gold200),
                },
                outline: {
                    "lodestar-light": toRgba(lodestarColors.neutralAccessible, 0.4), //no token exists
                    "ursa-light": color("color--icons--neutral--weakest", ursaColors.neutral75),
                },
            },
            invalid: {
                rest: {
                    "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                    "ursa-light": color("color--icons--error--default", ursaColors.red500),
                },
                hover: {
                    "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                    "ursa-light": color("color--icons--destructive--stronger", ursaColors.red600),
                },
                active: {
                    "lodestar-light": color("color--background--error--default", lodestarColors.buttonDestructive),
                    "ursa-light": color("color--background--destructive--strongest", ursaColors.red700),
                },
            },
        },
    },
});

export const checkboxBorderTheme = themed({
    borderRadius: {
        16: {
            "lodestar-light": border.radius05,
            "ursa-light": border.radius10,
        },
        20: {
            "lodestar-light": border.radius05,
            "ursa-light": border.radius20,
        },
    },
});

export const checkboxMotionTheme = themed({
    background: {
        "lodestar-light": "",
        "ursa-light": `background-color ${motion.animation.default}, color ${motion.animation.default}`,
    },
    flag: "",
    star: "",
    check: {
        "lodestar-light": "",
        "ursa-light": `stroke-dashoffset 4500ms ${motion.easing.default} 100ms`,
    },
});

export const checkboxLabelTheme = themed({
    color: {
        rest: "inherit",
        disabled: {
            "lodestar-light": toRgba(lodestarColors.neutralDark40, 0.4), //no token exists
            "ursa-light": color("color--background--neutral--strongest", ursaColors.neutral300),
        },
    },
    gap: {
        "lodestar-light": "8px",
        "ursa-light": "6px",
    },
    fontWeight: {
        "lodestar-light": typography.fontWeight.regular,
        "ursa-light": typography.fontWeight.medium,
    },
});

export const checkmarkTheme = themed({
    size: {
        16: {
            "lodestar-light": 16,
            // The icon in ursa is always 20px.
            "ursa-light": 20,
        },
        20: {
            "lodestar-light": 20,
            "ursa-light": 20,
        },
    } as const,
});
